// import React from 'react';
import { useStoreStore } from '../../stores/store-store';

export default function StoreSwitcher() {
  const { 
    availableStores, 
    currentStore, 
    switchStore, 
    isLoading 
  } = useStoreStore();

  if (isLoading) {
    return (
      <div className="flex items-center space-x-2">
        <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
        <span className="text-sm text-gray-600">Loading stores...</span>
      </div>
    );
  }

  if (availableStores.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center space-x-4">
      <span className="text-[15px] leading-none font-medium text-[#32415f]">Stores:</span>
      <div className="flex items-center space-x-2">
        {availableStores.map((store) => (
          <div key={store.id} className="flex items-center space-x-2">
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="radio"
                name="store-switch"
                className="sr-only peer"
                checked={currentStore?.id === store.id}
                onChange={() => switchStore(store.id)}
              />
              <div className={`
                w-10 h-5 peer-focus:outline-none peer-focus:ring-4 
                peer-focus:ring-blue-300 rounded-full peer 
                ${currentStore?.id === store.id 
                  ? 'peer-checked:after:translate-x-5 peer-checked:after:border-white after:content-[""] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-[#1E3255]' 
                  : 'bg-[#78829D] after:content-[""] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4'
                }
              `}></div>
            </label>
            <span className="text-[15px] leading-none font-medium text-[#32415f]">
              {store.name}
            </span>
            <img
              src="/img/Frame.svg"
              alt="Store icon"
              className="h-[27.5px] w-[27.5px] object-contain"
            />
            {currentStore?.id === store.id && (
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
